// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.feedclaims.RentalManagerUserFeedClaimsV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserFeedClaimsV2WebApiHandler_request } from '@zg-rentals/ts-rental-manager-api-client';

import type { UserFeedClaimsRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserFeedClaimsV2WebApiHandler_request_Args {
  postData: UserFeedClaimsRequestDto;
}

export type RentalManagerUserFeedClaimsV2WebApiHandler_request_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserFeedClaimsV2WebApiHandler_request_Args
>;

/**
 * Create a claim feed listing request
 */
export const useRentalManagerUserFeedClaimsV2WebApiHandler_request = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFeedClaimsV2WebApiHandler_request_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFeedClaimsV2WebApiHandler_request_Args) =>
      RentalManagerUserFeedClaimsV2WebApiHandler_request(args.postData, httpClient),
  });
};
